import DashboardPageFrame from './DashboardPageFrame.jsx';
import { INPUT_TABS } from '../constants/tabs';
import '../styles/dashboard-progress-management.css';

export default function DashboardInputLayout({
  inputTabIndex,
  toolbar,
  filters,
  children,
  secondaryTabs = INPUT_TABS,
  mainClassName = 'pm-main',
  rootClassName = 'pm-page',
  primaryTabActiveIndex = 1,
}) {
  return (
    <DashboardPageFrame
      mainClassName={mainClassName}
      primaryTabActiveIndex={primaryTabActiveIndex}
      rootClassName={rootClassName}
      secondaryTabActiveIndex={inputTabIndex}
      secondaryTabs={secondaryTabs}
      secondaryTabsContainerClassName="pm-secondary-tabs"
      stickyAreaClassName="pm-sticky-area"
    >
        <section className="pm-table-panel">
          {toolbar}
          {filters}
          {children}
        </section>
    </DashboardPageFrame>
  );
}
